import RequestClient from '@shared/services/main/request-client';
import { alertSuccess, alertError } from '@shared/services/base/alerts/common-alerts';
import { humanize, toItemName } from '@shared/lib/helpers/common';

/**
 * This prototype describes an Create events trait. Encapsulate business logics
 *
 * @class      CreateCallable (name)
 */
function CreateCallable(component) {
  this.component = component;
}

/**
 * Registers Create events, this follows naming convention
 *
 * @param      {Object}       self         The caller instance
 * @param      {CreateCallable}  service      The service
 * @param      {string}       module_name  The module name
 */
CreateCallable.prototype.registerCreateEvents = function(self, service) {
  var event_callback_map = {};
  event_callback_map[this.event_group.CREATE_PROCEED] = 'onCreateProceed';
  event_callback_map[this.event_group.CREATE_SUCCESS] = 'onCreateSuccess';
  event_callback_map[this.event_group.CREATE_FAIL]    = 'onCreateFail';
  this.registerEvents(event_callback_map, service);
  return this;
}

/**
 * Removes Create events.
 *
 * @param      {<type>}  self         The object
 * @param      {<type>}  service      The service
 * @param      {string}  module_name  The module name
 */
CreateCallable.prototype.removeCreateEvents = function() {
  this.removeEvents([
    this.event_group.CREATE_PROCEED,
    this.event_group.CREATE_SUCCESS,
    this.event_group.CREATE_FAIL
  ]);
  return this;
}

/**
 * Gives the request extra options,
 *
 * NOTE: this will override the same option keys
 *
 * @return     {Object}  The request extra options
 */
CreateCallable.prototype.extraCreateOptions = function() {
  return {};
}

/**
 * Called when Create proceed.
 *
 * @param      {Object}  arg1       The argument 1
 * @param      {object}  arg1.item  The item
 */
CreateCallable.prototype.onCreateProceed = function({item}) {
  console.log("CreateCallable::onCreateProceed" , item);
  this.addInterceptor();
  let token_source = this.renewCancelToken(RequestClient, this.event_group.CREATE_PROCEED);
  this.getComponent().setState({loader: true});

  const options = this.extraCreateOptions();
  let request = RequestClient.post(this.create_endpoint, item, {
    cancelToken: token_source.token,
    ...options
  });
  this.bindResultEvents(
    request,
    this.event_group.CREATE_SUCCESS,
    this.event_group.CREATE_FAIL
  );

}

/**
 * Called on create success intercept.
 */
CreateCallable.prototype.onCreateInterceptSuccess = function() {
  const item_name = toItemName(this.item_name || this);
  alertSuccess({
    message: humanize(item_name) + ' is successfully saved',
    onResolve: this.onCreateResolved.bind(this)
  });
}

/**
 * Called when create resolved.
 */
CreateCallable.prototype.onCreateResolved = function() {
  if (this.getComponent().after_create_back_disable === undefined) {
    window.history.back();
  }
}


/**
 * Called on Create success.
 *
 * @param      {Object}  response  The response
 */
CreateCallable.prototype.onCreateSuccess = function(response) {
  console.log("CreateCallable::onCreateSuccess" , response);
}

/**
 * Called on Create fail.
 *
 * @param      {Object}  error   The error
 */
CreateCallable.prototype.onCreateFail = function(error) {
  console.log("CreateCallable::onCreateFail" , error);
}

/**
 * Called on create success intercept.
 *
 * @param      {Object}  response  The response
 */
CreateCallable.prototype.onCreateInterceptFail = function(response) {
  const { data: { message } } = response
  alertError({
    title: 'Create Failed',
    message: message,
  });
}


export default CreateCallable;
